/** @format */

import { RepaireRecordIssuedStatusMap, ReviewStatusMap } from '@/types/exception-management/dictionaries';
import Utils from '@root/utils/common';
import moment from 'moment';

const reviseStartTime = moment().startOf('day'); // 开始时间
const reviseEndTime = moment().endOf('day'); // 结束时间

export default function() {
  return {
    adapterDataForViewModel: {
      //下发状态
      repaireRecordIssuedStatusHandler: {
        list: Utils.toLabelVal(RepaireRecordIssuedStatusMap),
        model: []
        // onChange: arr => {
        //   this.filterParam.liftCauses = arr.join(',')
        // },
      },
      releaseCausesHandler: {
        model: [],
        onChange: (arr: any[]) => {
          this.filterParam.releaseCauses = arr.join(',');
        }
      },
      reviewStatushandler: {
        dataMap: ReviewStatusMap,
        model: [],
        onChange: (str: String) => {
          this.filterParam.reviewStatus = str;
        }
      },

      plateModel: false
    },
    // stopDay: '', //停车：几天以上
    parkIds: [], // 车场ID集合,多车场逗号分隔
    plateHead: '', // 车牌头
    plateTail: '',

    reviseStartTime: reviseStartTime.format('YYYY-MM-DD HH:mm:ss'), // 开始时间
    reviseEndTime: reviseEndTime.format('YYYY-MM-DD HH:mm:ss'), // 结束时间

    releaseCauses: '', //放行原因
    reviewStatus: '', //审核状态
    operater: '', //操作人姓名
    reviseFrom: [], //操作来源
    revisePlateNum: '', //修正位数
    // cleanStartTime: '',
    // cleanEndTime: '',
    // authTypes: [], // 车辆类型,多个类型逗号分隔（00：临停小车 01：临停大车 02：产权车 03：月卡车）
    // carTypes: [], // 车型,多个类型逗号分隔,00：小车，01：大车
    reviseTimeOrderBy: '',
    revisePlateNumOrderBy: ''
  };
}
